<div class="zoom-container">
  <button class="zoom-button" (click)="zoomOut()" tooltip="Zoom Out">
    <span class="pi pi-search-minus"></span>
  </button>

  <button class="zoom-button" (click)="zoomIn()" tooltip="Zoom In">
    <span class="pi pi-search-plus"></span>
  </button>

  <span class="zoom-display">
    <small>{{ zoomRatio() }}%</small>
  </span>

  <button class="zoom-button" (click)="resetZoom()" tooltip="Reset Zoom">
    <span class="pi pi-stop"></span>
  </button>
</div>
